import Billing from 'pages/ClinicSettings/Billing/Billing';

export default Billing;
